import { baseApi } from "@/utils/constants";
import { Fetcher } from "@/utils/fetcher";
import axios from "axios";

const redirect = new Fetcher("url-redirection");
redirect.setUseToken(false);

// redirect url: /api/v1/url-redirection/redirect?url=https://gng.bitcommerz.com/product/vivo-v27e
export const getRedirectUrl = (url: string) =>
  redirect.get<{ data: string }>(`/redirect?url=${url}`);

// get shops: /api/v1/storefront/warehouse
export const getShops = (): Promise<StoreItem[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(`${baseApi}storefront/warehouse`);
      resolve(response.data);
    } catch (err) {
      reject(err);
    }
  });
};

// get shop by id: /api/v1/storefront/warehouse/shop/:id
export const getShopById = (id: string): Promise<StoreItem> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${baseApi}storefront/warehouse/shop/${id}`
      );
      resolve(response.data);
    } catch (err) {
      reject(err);
    }
  });
};

export const getShopBySlug = (slug: string): Promise<StoreItem> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${baseApi}storefront/warehouse/shop?slug=${slug}`
      );
      resolve(response.data);
    } catch (err) {
      reject(err);
    }
  });
};

// /api/v1/country/log
export const postApiLog = (data: any[]): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(`${baseApi}country/log`, data);
      resolve(response.data);
    } catch (err) {
      reject(err);
    }
  });
};

// {{apiUrl}}/api/v1/product/storefront/seo
export const getPageRouteSlugs = (): Promise<PageRouteSlugs> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(`${baseApi}product/storefront/site-map/seo`);
      resolve(response.data);
    } catch (err) {
      reject(err);
    }
  });
};
